import React from "react";
import _ from "lodash";

import {useConfirmationModalContext} from "../../../components/ConfirmationModalContextProvider";
import useUnsavedChangesStyles from "../unsavedChangesStyles";
import {validateScheme} from "../AssetForm/forms_schemes";

function getFormDataCheckSum(formData){
  return JSON.stringify(_.omitBy(formData, _.isNil));
}

function getLinksChecksum(links){
  return JSON.stringify(_.orderBy(links.map(l => _.pick(l, ['id', 'type_id'])), ['type_id', 'id']));
}

const useFormController = (formScheme, defaultFormData={}, defaultLinks=[]) => {
  const confirmContext = useConfirmationModalContext();
  const [formData, setFormData] = React.useState(defaultFormData);
  const [formDataErrors, setFormDataErrors] = React.useState({});
  const initialFormDataCheckSum = React.useRef();

  const [links, setLinks] = React.useState(defaultLinks);
  const initialLinksCheckSum = React.useRef(getLinksChecksum(defaultLinks));

  const customClasses = useUnsavedChangesStyles();

  const validateForm = () => {
    let validationErrors = {};
    if (formScheme) {
      validationErrors = validateScheme(formScheme, formData);

      if (!_.isEmpty(validationErrors)) {
        setFormDataErrors(validationErrors);
      }
    }

    return Object.keys(validationErrors).length === 0;
  };

  React.useEffect(() => {
    // set checkSums whenever 'updated' timestamp changed (auto set on backend)
    initialFormDataCheckSum.current = getFormDataCheckSum(formData);
    initialLinksCheckSum.current = getLinksChecksum(defaultLinks);
  }, [formData.updated]);

  const handleFormChange = (field, value) => {
    const newFormData = {...formData};
    _.set(newFormData, field, value);
    setFormData(newFormData);

    const newErrors = {...formDataErrors};
    _.unset(newErrors, field);
    setFormDataErrors(newErrors);
  };

  const reset = () => {
    setFormData(defaultFormData);
    setFormDataErrors({});
    setLinks(defaultLinks);
  };

  const checkForUnsavedChanges = async (onSave) => {
    if (getFormDataCheckSum(formData) === initialFormDataCheckSum.current &&
        getLinksChecksum(links) === initialLinksCheckSum.current){
      return true;  // no changes
    }

    const res = await confirmContext.confirm(
      'Wollen Sie Ihre Änderungen speichern?', 'Ja, speichern', 'Nein, verwerfen', <><i className={'far fa-exclamation-triangle'} />Nicht gespeicherte Änderungen</>,
      customClasses
    );
    if(res === false){ // cancel - No
      reset();
      return true;
    }
    if(res === true){ // yes - save
      onSave();
    }

    return false;
  };

  return [
    formData, setFormData, formDataErrors, setFormDataErrors, checkForUnsavedChanges, links, setLinks, validateForm,
    handleFormChange, reset
  ]
};

export default useFormController;